module.exports = __webpack_public_path__ + "media/src/public/img/scan-efa91423b6392ae3cc6f8f658c7db1f1.jpg";